<template>
  <base-dialog
    :action-name="''"
    :close="onClose"
    :title="'Find Customer'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <v-row>
        <v-col cols="12">
          <customer-list
            :perform-init-search="false"
            :emit-selected="true"
            @selected-customer="onSelectedCustomer"
          />
        </v-col>
      </v-row>
    </template>
  </base-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isEmpty } from 'lodash'
import BaseDialog from "@/components/Common/BaseDialog"
import { readableCouponTerms } from "../../services/stripe.service"
import CustomerList from "./CustomerList"

export default {
  components: { CustomerList, BaseDialog },
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters([ '' ]),

  },
  methods: {
    ...mapActions([ 'searchCustomers' ]),
    onSelectedCustomer(customer){
      this.$emit('action', customer)
    },
    onClose() {
      this.$emit('close')
    },
    onAction() {

    }
  }
}
</script>
